import OutgoingNode from './OutgoingNode';
import IncomingNode from './IncomingNode';
import ApplicationNode from './ApplicationNode';
import ExternalApplicationNode from './ExternalApplication';

const nodeTypes = {
  outgoingNode: OutgoingNode,
  incomingNode: IncomingNode,
  applicationNode: ApplicationNode,
  externalApplicationNode: ExternalApplicationNode,
};

export default nodeTypes;
